import { Editor, EditorContent } from '@tiptap/react';
import React, { FC } from 'react';

import { Box, StyleProps } from '@bonusly/design-system';

import { useInputRole } from './hooks/use-input-role';
import { InputStyles, useInputStyle } from './hooks/use-input-style';

export interface RichMediaInputProps extends StyleProps {
	editor: Editor | null;
	inputStyles?: InputStyles;
	uniqueId: string;
}

export const RichMediaInput: FC<RichMediaInputProps> = ({ editor, inputStyles, uniqueId, ...props }) => {
	const style = useInputStyle(inputStyles);
	useInputRole(uniqueId);

	if (!editor) {
		return null;
	}

	return (
		<Box css={style} fontSize="xl" letterSpacing="-0.01em" lineHeight={8} overflow="hidden" {...props}>
			<EditorContent
				id={`editor-${uniqueId}`}
				editor={editor}
				style={{
					height: '100%',
					...(inputStyles as React.CSSProperties)
				}}
			/>
		</Box>
	);
};
